import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

// Fetch all subscription plans
export const fetchPlans = createAsyncThunk('billing/fetchPlans', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/api/payments/plans/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch plans');
  }
});

// Fetch current subscription for the logged-in doctor
export const fetchCurrentSubscription = createAsyncThunk(
  'billing/fetchCurrentSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/payments/subscriptions/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch subscription');
    }
  }
);

// Fetch billing/payment history
export const fetchPaymentHistory = createAsyncThunk(
  'billing/fetchPaymentHistory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/payments/payment-history/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch payment history');
    }
  }
);

// Subscribe to a plan (returns Razorpay subscription_id and key)
export const subscribeToPlan = createAsyncThunk(
  'billing/subscribeToPlan',
  async (planId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/payments/subscribe/', { plan_id: planId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Subscription failed');
    }
  }
);

// Cancel active subscription
export const cancelSubscription = createAsyncThunk(
  'billing/cancelSubscription',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/payments/subscription/cancel/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Cancel failed');
    }
  }
);

const subscriptionSlice = createSlice({
  name: 'billing',
  initialState: {
    plans: [],
    currentSubscription: null,
    history: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Plans
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Current Subscription
      .addCase(fetchCurrentSubscription.fulfilled, (state, action) => {
        state.currentSubscription = action.payload;
      })

      // Subscribe to Plan
      .addCase(subscribeToPlan.fulfilled, (state, action) => {
        // This will just return subscription_id and razorpay_key
        // Actual activation happens after Razorpay payment success
      })

      // Cancel Subscription
      .addCase(cancelSubscription.fulfilled, (state) => {
        state.currentSubscription = null;
      })

      // Billing History
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        state.history = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;
